import { render, staticRenderFns } from "./SearchList.vue?vue&type=template&id=df1c38de&scoped=true"
import script from "./SearchList.vue?vue&type=script&lang=js"
export * from "./SearchList.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=df1c38de&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1c38de",
  null
  
)

export default component.exports